var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 10.125C7.82812 10.125 7.5 9.79688 7.5 9.375V8.625C7.5 8.25 7.82812 7.875 8.25 7.875H15.75C16.125 7.875 16.5 8.25 16.5 8.625V9.375C16.5 9.79688 16.125 10.125 15.75 10.125H8.25ZM7.5 13.875V13.125C7.5 12.75 7.82812 12.375 8.25 12.375H15.75C16.125 12.375 16.5 12.75 16.5 13.125V13.875C16.5 14.2969 16.125 14.625 15.75 14.625H8.25C7.82812 14.625 7.5 14.2969 7.5 13.875ZM12 19.5938C12.75 19.5938 13.5 19.3594 14.1562 18.8438L24 11.7656V21.75C24 23.0156 22.9688 24 21.75 24H2.25C0.984375 24 0 23.0156 0 21.75V11.7656L9.79688 18.8438C10.4531 19.3594 11.2031 19.5938 12 19.5938ZM23.1094 7.64062C23.6719 8.10938 24 8.71875 24 9.42188V9.9375L19.5 13.1719V4.5H4.5V13.1719L0 9.9375V9.42188C0 8.71875 0.328125 8.0625 0.84375 7.64062C1.26562 7.35938 1.64062 7.03125 2.25 6.60938V4.5C2.25 3.28125 3.23438 2.25 4.5 2.25H8.10938C8.25 2.15625 8.39062 2.0625 8.53125 1.96875C9.32812 1.40625 10.875 0 12 0C13.0781 0 14.625 1.40625 15.4219 1.96875C15.5625 2.0625 15.7031 2.15625 15.8438 2.25H19.5C20.7188 2.25 21.75 3.28125 21.75 4.5V6.60938C22.3125 7.03125 22.6875 7.35938 23.1094 7.64062Z",
    fill: "#086AD7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/Email.0d30bd106d7c146baed877db9ed14439.svg";
export { ForwardRef as ReactComponent };